import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useAdminAuth() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  const headers = () => ({ Authorization: `Bearer ${localStorage.getItem("seed_admin_token")}` });

  useEffect(() => {
    const token = localStorage.getItem("seed_admin_token");
    if (!token) {
      navigate("/admin/login");
      return;
    }
    axios
      .get(`${API}/auth/me`, { headers: headers() })
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("seed_admin_token");
        navigate("/admin/login");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    localStorage.removeItem("seed_admin_token");
    navigate("/admin/login");
  };

  return { user, headers, logout, navigate };
}
